"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerLocalizationStore = exports.LocalizationStore = void 0;
const seamless_immutable_1 = __importDefault(require("seamless-immutable"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const epic_alt_utils_1 = require("epic-alt-utils");
const localization_1 = require("@epic-core/localization");
let bootstrapStoreState;
/**
 * LocalizationStore
 *
 * Meant to be reused in order to store common message properties in a React store. You will need
 *  to call registerLocalizationStore() with the alt instance and bootstrap object with messages.
 */
let LocalizationStore = class LocalizationStore {
    getStateFunctions() {
        return {
            message(code, args) {
                return (0, localization_1.getMessage)(this.messages, code, args);
            }
        };
    }
    constructor() {
        this.on('error', (error) => { console.error(error); });
        if (typeof bootstrapStoreState === 'function') {
            this.on('bootstrap', epic_alt_utils_1.seamlessBootstrap.bind(this, (state) => {
                return state.merge(bootstrapStoreState());
            }));
        }
        const initialState = (0, seamless_immutable_1.default)({
            supportedLocales: ['en_US'],
            locale: 'en_US',
            messages: {}
        });
        this.state = initialState.merge(this.getStateFunctions());
        if (bootstrapStoreState instanceof Function) {
            this.state = this.state.merge(bootstrapStoreState(), { deep: true });
        }
        else if (bootstrapStoreState) {
            this.state = this.state.merge(bootstrapStoreState, { deep: true });
        }
    }
};
LocalizationStore = __decorate([
    epic_alt_utils_1.seamlessImmutable
], LocalizationStore);
exports.LocalizationStore = LocalizationStore;
function registerLocalizationStore(Alt, stateObject, storeName) {
    if (!window_or_global_1.default.__epic_react_common_localization) {
        bootstrapStoreState = stateObject;
        window_or_global_1.default.__epic_react_common_localization = Alt.createStore(LocalizationStore, storeName || 'LocalizationStore');
    }
    return window_or_global_1.default.__epic_react_common_localization;
}
exports.registerLocalizationStore = registerLocalizationStore;
//# sourceMappingURL=LocalizationStore.js.map